export default __webpack_public_path__ + "static/header-bg-ac0fca7fa84de8643839444a51fac254.webp";